<template>
    <ol class="mt4 list-decimal pl5">
        <slot />
    </ol>
</template>
